import * as React from 'react';
import '../css/section-message.sass';
import Popup from './Popup';
import CampfireButton from './CampfireButton';

interface MultipleMessageType {
  type: 'info' | 'warning' | 'error' | 'success' | 'highlight' | 'default';
  id?: string;
  message: React.ReactNode;
}

interface MultipleMessagesPopupProps {
  messages: MultipleMessageType[];
  onClose?: Function;
}

interface HeadingType {
  [key: string]: string;
}

export default function MultipleMessagesPopup(
  props: MultipleMessagesPopupProps
) {
  const headings: HeadingType = {
    info: 'Info',
    error: 'Error',
    warning: 'Warning',
    success: 'Success'
  };
  const messages = props.messages.map((msg: any) => (
    <div key={msg.id} className="message">
      <div id={msg.id} className={`${msg.type} icon`}>
        <span className="typeHeading">{headings[msg.type]}</span>
      </div>
      {msg.message}
    </div>
  ));
  return (
    <Popup
      modal
      displayCloseButton
      position="center"
      onClose={props.onClose}
      className="multipleMessagePopup"
    >
      <div className="multipleMessagePopupContent">
        <div className="title">Heads up</div>
        <div className="description">{messages}</div>
        <div className="groupbuttons">
          <CampfireButton
            name="mmgotitbtn"
            id="mmgotitbtn"
            label="Got it, thanks"
            color="water"
            ghost
            frosty
            onClick={props.onClose}
          />
        </div>
      </div>
    </Popup>
  );
}
